import { databaseRef } from "../Utilities/firebase";

/* ------------- ACTIONS ------------- */
export const REMOVE_TRASH_ITEM = "REMOVE_TRASH_ITEM";
export const ADD_TRASH_TO_SHOP = "ADD_TRASH_TO_SHOP";

/* ------------- ACTION CREATORS ------------- */
export function removeTrashItem(user, item, removeAll) {
  // Get current quantity from trash
  let decQuant = 0;
  databaseRef
    .ref("users/" + user + "/trash/" + item.EANcode)
    .child("quantity")
    .once("value", function (snapshot) {
      let curVal = snapshot.val();
      decQuant = curVal - 1;
    });
  if (removeAll) {
    decQuant = 0;
  }
  if (Array.isArray(item.dates)) {
    if (item.dates.length > 1) {
      item.dates.shift();
    }
  }
  //remove item
  if (decQuant === 0) {
    databaseRef
      .ref("users/" + user + "/trash")
      .child(item.EANcode)
      .remove();
  } else {
    let newItem = { ...item, quantity: decQuant };
    databaseRef
      .ref("users/" + user + "/trash")
      .child(item.EANcode)
      .set(newItem);
  }

  return { type: REMOVE_TRASH_ITEM };
}

export function addTrashToShopping(user, item) {
  var carbon_fp = "";
  var water_fp = "";

  if (item.carbon_fp !== undefined) {
    carbon_fp = item.carbon_fp;
  }

  if (item.water_fp !== undefined) {
    water_fp = item.water_fp;
  }

  // Get quantity from shopping
  let quantity = 1;
  databaseRef
    .ref("users/" + user + "/shopping/" + item.EANcode)
    .child("quantity")
    .once("value", function (snapshot) {
      let currentQuantity = snapshot.val();
      quantity = currentQuantity + quantity;
    });

  var date = new Date().toISOString();

  var updatedItem = {
    EANcode: item.EANcode,
    fullname: item.fullname,
    size: item.size,
    unit_id: item.unit_id,
    name: item.name,
    dates: [date],
    comment: item.comment,
    quantity: quantity,
    amount: 100,
    dep_id: item.dep_id,
    dep_name: item.dep_name,
    cat_id: item.cat_id,
    cat_name: item.cat_name,
    subcat_id: item.subcat_id,
    subcat_name: item.subcat_name,
    image: item.image,
    carbon_fp: carbon_fp,
    water_fp: water_fp,
  };

  databaseRef
    .ref("users/" + user + "/shopping")
    .child(item.EANcode)
    .set(updatedItem);

  return { type: ADD_TRASH_TO_SHOP };
}
